<template>
  <div>
    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">债权文书</div>
      </div>
    </div>

    <div class="flow-box">
      <div class="flow-item">
        <div class="flow-content">
          <div class="line"></div>
          <div class="item-body">
            <div class="file-box">
              <img
                class="wj-image"
                src="../../../../assets/images/business/wj.png"
                alt=""
                @click="onChoose('contractFile')"
              />
              <div class="name" @click="onChoose('contractFile')">
                {{ info.fileUrlMap.contractFileName }}
              </div>
              <div
                v-if="
                  info.basicInfo.bizStatus === '审核中' ||
                  info.basicInfo.bizStatus === '已出证'
                "
                class="tool"
                @click="onDownLoad(info)"
              >
                下载
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">公证文书</div>
      </div>
    </div>
    <div class="flow-box">
      <div class="flow-item">
        <div class="flow-content">
          <div class="line"></div>
          <div class="item-body">
            <div class="file-box" @click="onChoose('idCardFace')">
              <img
                class="wj-image"
                src="../../../../assets/images/business/wj.png"
                alt=""
              />
              <div>身份证人像面</div>
            </div>
            <div class="file-box" @click="onChoose('idCardLogo')">
              <img
                class="wj-image"
                src="../../../../assets/images/business/wj.png"
                alt=""
              />
              <div>身份证国徽面</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
        
  <script>
import BaseApi from "@lib/baseApi.js";
import download from "@lib/download.js";

export default {
  name: "fileListView",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  components: {},

  data() {
    return {};
  },

  created() {},
  mounted() {},

  methods: {
    onChoose(type) {
      this.$emit("onChoose", type);
    },

    onDownLoad(row) {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/file/download", { id: row.basicInfo.id })
        .then((data) => {
          this.$store.commit("showLoading", false);
          if (data.datas.zipUrl) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.setAttribute("id", "startDown");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
            } catch (e) {}
            // window.open(data.datas.zipUrl);
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
          this.$store.commit("showLoading", false);
        });
    },
  },
};
</script>
        
  <style scoped lang='scss'>
.title-item {
  padding: 0 15px;
  display: flex;
  align-items: center;
  .left-label {
    display: flex;
    align-items: center;

    .title-line {
      width: 4px;
      height: 19px;
      background: #d81212;
      border-radius: 4px;
    }
    .title-text {
      margin-left: 9px;
      color: #787878;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .right-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #787878;
    line-height: 15px;
    font-size: 13px;
    .bj-image {
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }
  }
}

.flow-box {
  margin-top: 23px;
  padding: 0 25px 0 30px;
  .flow-item {
    margin-bottom: 23px;
    .flow-title {
      font-size: 13px;
      color: #505050;
      line-height: 15px;
      margin-bottom: 11px;
    }

    .flow-content {
      display: flex;
      justify-content: flex-end;
      .line {
        width: 1px;
        background: #db1c1b;
      }
      .item-body {
        // width: 293px;
        flex: 1;
        background: #ffffff;
        padding: 13px 25px 13px 0;
        // margin: 13px 0 13px 24px;
        .file-box {
          border-radius: 2px;
          margin-left: 24px;
          margin-bottom: 8px;
          padding: 11px;
          box-sizing: border-box;
          width: 100%;
          display: flex;
          align-items: center;
          border: 1px solid #e9e9e9;
          font-size: 13px;
          line-height: 15px;
          font-weight: 400;
          color: #505050;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0;
          }
          .wj-image {
            width: 20px;
            height: 20px;
            margin-right: 14px;
          }
          .name {
            flex: 1;
          }
          .tool {
            color: #db1c1b;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
        